import { ShieldAlert } from "lucide-react";
import type { JSX } from "react";

/**
 * Chrome-level presentation of the backend-owned session/cache mode. Only
 * degraded modes render; the label is the backend diagnostic code so the
 * banner never invents local semantics.
 */
export function SessionModeBanner({
  mode,
  diagnosticCode,
}: {
  mode: "booting" | "fresh" | "readOnly" | "unauthenticated" | "blocked" | "failed";
  diagnosticCode: string | null;
}): JSX.Element | null {
  if (mode !== "readOnly" && mode !== "blocked") {
    return null;
  }
  return (
    <div className="session-mode-banner" role="status">
      <ShieldAlert size={16} aria-hidden="true" />
      <span>{mode === "readOnly" ? "Read-only session" : "Session blocked"}</span>
      {diagnosticCode ? <em>{diagnosticCode}</em> : null}
    </div>
  );
}
